import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q8: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interior', 'steeringWheels'],
};

const q8etron: PartialCarConfiguration = {
	...q8,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/q8etron.html',
};

const q8sbetron: PartialCarConfiguration = {
	...q8,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/q8sbetron.html',
};

const sq8etron: PartialCarConfiguration = {
	...q8,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/sq8etron.html',
};

const sq8sbetron: PartialCarConfiguration = {
	...q8,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/sq8sbetron.html',
};

const q8etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const q8sbetron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq8etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq8sbetron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q8etron, q8etron_ui, q8sbetron, q8sbetron_ui, sq8etron, sq8etron_ui, sq8sbetron, sq8sbetron_ui };
